import axios from "axios";


export async function getResults(origin, originId, courseId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/attempts/results`,{ params: {origin: origin, originId: parseInt(originId), moduleId: courseId} })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

/**
 * Marca el cuestionario como finalizado (examen, simulacro, práctica, lección).
 * @throws si el backend no confirma finished=true
 */
export async function setQuestionnaireFinished(origin, originId, courseId) {
  const moduleId = Number(courseId);
  const resolvedOriginId = Number(originId);
  if (Number.isNaN(moduleId) || Number.isNaN(resolvedOriginId)) {
    throw new Error("Datos de curso o actividad inválidos.");
  }
  const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/attempts/finish`, {
    moduleId,
    origin,
    originId: resolvedOriginId,
  });
  if (response.data !== true) {
    throw new Error("El servidor no confirmó la finalización.");
  }
  return true;
}
